import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-use';
import { useModalsActions } from 'shared/ui/SideModal';
import { EDIT_CAMPAIGN_PAGE_KEY, EDIT_CAMPAIGN_MODAL_PAGES } from 'entities/campaign';
import { ZipsEditorModal } from 'features/edit-zips';

export const useModalPages = (setEdit: () => void, campaignId: number) => {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const currentModalPage = query.get(EDIT_CAMPAIGN_PAGE_KEY) ?? null;
  const { open } = useModalsActions();
  const isEditZips = currentModalPage === EDIT_CAMPAIGN_MODAL_PAGES.edit_zips;
  const isMinIncome = currentModalPage === EDIT_CAMPAIGN_MODAL_PAGES.min_income;
  const isWeeklyBudget = currentModalPage === EDIT_CAMPAIGN_MODAL_PAGES.weekly_budget;
  const isBidRange = currentModalPage === EDIT_CAMPAIGN_MODAL_PAGES.bid_range;

  useLayoutEffect(() => {
    if (currentModalPage) {
      setEdit();
      if (isEditZips) {
        open(<ZipsEditorModal campaignId={campaignId} />);
      }
    }

    return () => {
      if (currentModalPage) {
        query.delete(EDIT_CAMPAIGN_PAGE_KEY);
        history.push({ search: query.toString() });
      }
    };
  }, [currentModalPage, campaignId, setEdit, isEditZips, isMinIncome, isWeeklyBudget, isBidRange]);

  return { isMinIncome, isWeeklyBudget, isBidRange };
};
